import { memo } from 'react';

import SvgIcon from '@material-ui/core/SvgIcon';

import { colors } from '../theme/palette';
import { SvgIconProps } from './SvgIcon.types';

export const CloseWarningIcon = memo(({ className, color = colors.primary.main }: SvgIconProps) => {
  return (
    <SvgIcon className={className} width="17" height="16" viewBox="0 0 17 16" fill="none" fontSize="inherit">
      <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="8.5" cy="8" r="6" fill={color} />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.34836 8.00007L11.3241 6.02432C11.5586 5.78973 11.5586 5.41054 11.3241 5.17595C11.0895 4.94135 10.7103 4.94135 10.4757 5.17595L8.5 7.1517L6.5243 5.17595C6.28971 4.94135 5.91053 4.94135 5.67594 5.17595C5.44135 5.41054 5.44135 5.78973 5.67594 6.02432L7.65164 8.00007L5.67594 9.97583C5.44135 10.2104 5.44135 10.5896 5.67594 10.8242C5.79294 10.9412 5.94653 11 6.10012 11C6.25371 11 6.4073 10.9412 6.5243 10.8242L8.5 8.84845L10.4757 10.8242C10.5927 10.9412 10.7463 11 10.8999 11C11.0535 11 11.2071 10.9412 11.3241 10.8242C11.5586 10.5896 11.5586 10.2104 11.3241 9.97583L9.34836 8.00007Z"
          fill="#FFFFFF"
        />
      </svg>
    </SvgIcon>
  );
});
